import React from 'react';
import styled from 'styled-components';
import { media, theme } from '@marketing-site/styles';
import { Helpers, RichTextToHtml } from '@marketing-site/utils';
import CtaButton from '../cta-button';
import { IHeroProductAlias } from './HeroProduct';
import { ICtaButton } from '@marketing-site/types/shared.model';
import { Box, Button, Stack, Typography } from '@mui/material';

type IHeroCareers = IHeroProductAlias & { secondCtaButton?: ICtaButton };
export const HeroCareers = ({
  children,
  ...props
}: React.PropsWithChildren<IHeroCareers>) => {
  const handleClick = (props: any) => {
    const sanitizedText = props.headline.toLowerCase().replace(/ /g, '_');
    window?.gtag('event', sanitizedText, {
      event_category: 'click',
      event_label: 'cta_button',
    });

    window?.open(
      Helpers.setLink(props.link),
      props.openInNewTab ? '_blank' : '_self'
    );
  };

  return (
    <Stack
      direction={{ mobile: 'column-reverse', desktop: 'row' }}
      alignItems={{ mobile: 'flex-start', tablet: 'center' }}
      gap={{ mobile: 50, desktop: 800 }}
      width={'92%'}
      maxWidth={1100}
      m={'0 auto'}
      py={'40px'}
    >
      <Stack
        flexGrow={1}
        flexShrink={1}
        flexBasis={{ mobile: '100%', tablet: '50%' }}
        alignSelf={{ mobile: 'flex-start', desktop: 'center' }}
      >
        {children}
        <Typography
          variant={'h2'}
          fontSize={{ mobile: '32px', desktop: '48px' }}
          fontWeight={800}
          lineHeight={{ mobile: '40px', desktop: '56px' }}
          my={'10px'}
        >
          {props.headline}
        </Typography>
        <Box maxWidth={440}>
          <Description>
            {RichTextToHtml(props.heroProductDescription.json)}
          </Description>
        </Box>

        <Stack direction={'row'} gap={200} mt={2}>
          {props.ctaButton && (
            <Button
              variant={'contained'}
              onClick={() => handleClick(props.ctaButton)}
              sx={{
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: 'none',
                },
              }}
            >
              {props.ctaButton.headline}
            </Button>
          )}
          {props.secondCtaButton && (
            <Button
              variant={'outlined'}
              onClick={() => handleClick(props.secondCtaButton)}
              sx={{
                backgroundColor: theme.colors.grey[100],
                color: theme.colors.black,
                border: `1px solid ${theme.colors.grey[100]}`,
                '&:hover': {
                  backgroundColor: theme.colors.skyblue,
                  color: theme.colors.white,
                },
              }}
            >
              {props.secondCtaButton?.headline}
            </Button>
          )}
        </Stack>
      </Stack>
      <Box
        flexGrow={1}
        flexShrink={1}
        flexBasis={{ mobile: '100%', tablet: '50%' }}
      >
        <Image src={props.image.url} />
      </Box>
    </Stack>
  );
};

const Description = styled.div`
  margin-bottom: 12px;

  > p {
    font-size: 14px;
    line-height: 20px;
    width: 100%;
    color: ${theme.colors.black};
  }
`;

const Image = styled.img`
  object-fit: contain;
  max-height: 420px;
  width: 100%;
  height: auto;
`;
